import { PromptSaveDirectiveModule } from '@b2b/common/directives/promptSave/promptSave.directive';
import { LoadCssResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreatePricingControllerModule } from './controllers/TemplatesCreatePricingController';

export const TemplatesCreatePricingView = angular
  .module('acme.view.application.templates.create.pricing', [
    uiRouter,
    'ui.bootstrap',
    'isteven-multi-select',
    PromptSaveDirectiveModule,
    TemplatesCreatePricingControllerModule,
    'acme.view.application.templates.modals.discount.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'TemplatesCreatePricingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Pricing',
      },
      resolve: {
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'TemplatesCreatePricingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Pricing',
      },
      params: {
        tab: '',
      },
      resolve: {
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    });
  }).name;
